import React from 'react';
import DebouncedSearchInput from './DebouncedSearchInput';

// Campo de busca do TopBar, no estilo da busca do WhatsApp: pílula preenchida
// e sem borda em repouso, borda `divider` no hover e, com foco, fundo de
// superfície e a borda primary padrão do MUI.
const SearchField = (props) => (
  <DebouncedSearchInput
    {...props}
    slotProps={{
      input: {
        sx: {
          borderRadius: 6,
          bgcolor: 'action.hover',
          '& .MuiOutlinedInput-notchedOutline': { borderColor: 'transparent' },
          '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'divider' },
          '&.Mui-focused': { bgcolor: 'background.paper' },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'primary.main' },
        },
      },
    }}
  />
);

export default SearchField;
